@let request = $request();
@let isDesktop = deviceService.isDesktop$ | async;

@if (request) {
  @if ($offlineState() === 'snapshot') {
    <div class="mb-3 rounded-lg bg-amber-100 px-4 py-3 text-amber-900">
      {{
        'offline.snapshot_message' | translate: { date: $snapshotFetchedAt() }
      }}
    </div>
  } @else if ($offlineState() === 'unavailable') {
    <div class="mb-3 rounded-lg bg-red-100 px-4 py-3 text-red-900">
      {{ 'offline.unavailable_message' | translate }}
    </div>
  }
  <div [class.pointer-events-none]="$isReadOnly()">
    @if (isDesktopSummary(isDesktop)) {
      <x-request-form-summary-desktop
        [request]="request"
        [isInitialLoad]="isInitialLoad"
        [mainFileGroups]="mainFileGroups"
        [requestComments]="requestComments"
        [getCheckList]="getCheckList"
        [shareRequestLink]="shareRequestLink"
        [openYaMaps]="openYaMaps"
        [requestDevices]="requestDevices"
        [devicesInstallQuality]="devicesInstallQuality$ | async"
        [formatDateWithLocale]="formatDateWithLocale"
        [files]="files"
        [fileCats]="fileCats"
        [dealDetails]="dealDetails"
        [workflowUrl]="$workflowUrl()"
        [workflowUrlButtonText]="$workflowUrlButtonText()"
        [workflowDataExists]="$requestWorkflowsExist()"
      />
    } @else {
      <x-request-form-summary-mobile
        [request]="request"
        [isInitialLoad]="isInitialLoad"
        [formatDateWithLocale]="formatDateWithLocale"
        [getCheckList]="getCheckList"
        [shareRequestLink]="shareRequestLink"
        [ePTS]="ePTS"
        [openYaMaps]="openYaMaps"
        [requestDevices]="requestDevices"
        [devicesInstallQuality]="devicesInstallQuality$ | async"
        [moreFileCatsWithFilesCount]="moreFileCatsWithFilesCount"
        [requestComments]="requestComments"
        [mainFileGroups]="mainFileGroups"
        [moreFileGroupsWithFiles]="moreFileGroupsWithFiles"
        [files]="files"
        [workflowUrl]="$workflowUrl()"
        [workflowUrlButtonText]="$workflowUrlButtonText()"
        [workflowDataExists]="$requestWorkflowsExist()"
      />
    }
  </div>
}
